// features/adminAsync.js or similar file

import { createAsyncThunk } from "@reduxjs/toolkit";
import { SecureGet, SecurePost } from "../services/axiosCall";
import apis from "../services/Apis";
import Alert from "../components/common/alert";

export const fetchAllQuestions = createAsyncThunk(
  "questions/fetchAllQuestions",
  async (subjectId, { rejectWithValue }) => {
    // console.log(subjectId);
    try {
      const response = await SecurePost({
        url: `${apis.GET_ALL_QUESTIONS}`,
        data: { subject: subjectId },
      });

      if (response.data.success) {
        // console.log(response.data.data);
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchAllTests = createAsyncThunk(
  "tests/fetchAllTests",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SecurePost({
        url: apis.GET_ALL_TESTS,
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchLevelSubjectWiseQuestion = createAsyncThunk(
  "questions/fetchLevelSubjectWiseQuestion",
  async ({ subjectId, level, difficulty, school, year, component, exam }, { rejectWithValue }) => {
    // console.log(subjectId, level, difficulty, school, year, component, exam);
    
    try {
      const response = await SecurePost({
        url: apis.GET_ALL_LEVEL_QUESTIONS,
        data: {
          subjectId,
          level,
          difficulty,
          school,
          year,
          component,
          exam,
        },
      });

      if (response.data.success) {
        // console.log(response.data.data);
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue([]);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
      return rejectWithValue([]);
    }
  }
);

export const updateCurrentTestBasicDetails = createAsyncThunk(
  "test/updateCurrentTestBasicDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await SecurePost({
        url: `${apis.GET_SINGLE_TEST_DETAILS_BASIC}`,
        data: { id },
      });

      if (response.data.success) {
        // console.log("Response",response.data.data);
        
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response ? error.response.data.message : error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const getAllTestsName = createAsyncThunk(
  "test/getAllTestsName",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SecurePost({
        url: apis.GET_ALL_TESTS_NAME,
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchConsultationTableData = createAsyncThunk(
  "consultation/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SecureGet({
        url: apis.GET_ALL_CONSULTATION_TUTOR,
      });

      if (response.data.success) {
        // console.log("response" ,response);
        
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);
